/**
 * Shared blog date formatter — used by the PostCard meta row and the
 * BlogPostPage metadata strip so the two always agree. en-AU, e.g. "20 Jun 2026".
 * Extracted from the duplicate definitions that previously lived in both files.
 *
 * UI-06 review fix: the timezone is PINNED. Blog dates are now BAKED into
 * prerendered HTML (the post seed and the H7 listing seeds), and the bake runs
 * in Australia/Sydney — without a pinned zone, a visitor in any UTC-negative
 * timezone computes a DIFFERENT calendar date for the same instant at
 * hydration, which React 19 verifies for text nodes → a recoverable hydration
 * error and a date that disagrees with what crawlers indexed. Sydney (not UTC)
 * because it matches both the baked output and the site's audience.
 */
export const formatDate = (date: Date): string =>
    date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Australia/Sydney' });
